import { parseJwt } from '@blocs.auth';

/**
 * @deprecated use `tokens.accessParsed.organizationId` instead from `useUserContext()`
 */
export const getTokenOrganizationId = (token?: string | null): number => {
  if (!token) {
    return null;
  }

  return parseJwt(token)?.organizationId;
};
